var toastTemplate = require('*views/partials/toast')
var $container
var fadeDuration = 500
var defaultShowDuration = 7000

module.exports = function (options) {
  var $el = $(toastTemplate(options))
  $container = $container || $('<div class="toaster-container">').appendTo('body')
  $el.hide().appendTo($container).fadeIn(fadeDuration)
  if (options.duration === false) {
    return;
  }
  setTimeout(function () {
    $el.fadeOut(fadeDuration, function () {
      $el.remove()
      options.complete && options.complete()
    })
  }, options.duration || defaultShowDuration)
}
